import { CentreVHUDto, ReferentielControllerApi } from 'lib_api/lib/api/gen';

export function fetchCentreVHU(
  refController: ReferentielControllerApi,
): Promise<CentreVHUDto[]> {
  return refController.getAllValidCentreVhuUsingGET().then(response => {
    return response.referenceDtoList;
  });
}
